import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppContext, SeoService } from '../../shared';
import { BlogPage } from  '../blog-page';

@Component({
  selector: 'suzhou-yun-logistics-technology-selects-linescape',
  template: require('./suzhou-yun-logistics-technology-selects-linescape.html'),
  styles: [require('./../blog.component.scss'), require('./suzhou-yun-logistics-technology-selects-linescape.scss')]
})
export class SuzhouYunLogisticsTechnologySelectsLinescape extends BlogPage {
  title = "Suzhou Yun Logistics Technology chooses Linescape Sailing Schedule Data";
  description = "Leading Chinese logistics platform adds Linescape's schedules to enhance freight rate data and vessel tracking.";

  constructor(route: ActivatedRoute, app: AppContext, seo: SeoService) {
    super(route, app, seo);
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/suzhou-yun-logistics-technology-selects-linescape/suzhou-yun-logistics-technology-selects-linescape.ts